module.exports = __webpack_public_path__ + "static/media/aramark.c607f381.png";